// extracted by mini-css-extract-plugin
export default {"productGrid":"p0-z","centerLink":"q0-z","productSection":"r0-z","item":"s0-z","ctaButton":"t0-z"};